import $ from 'gridstrap/lib/gs-zepto';

export class GSFormError {

	private root;

	set text(value) { this.root.html(this.format(value)); }

	private format(message) {
		if (typeof message === 'string') return message;
		return '<div>' + message.join('</div><div>') + '</div>';
	}

	constructor(root) {
		this.root = $(root);
	}

}
